import { nieswiadomyUmyslChapters } from './content';
export const nieswiadomyUmyslCommonMistakes = nieswiadomyUmyslChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('NAJCZĘSTSZE BŁĘDY'));
